import React from 'react';
import { Record } from 'immutable';

// Types
import { WorkspaceMeetingMode } from 'Shared/types/WorkspaceMeetingMode.type';

// Components
import MeetingAttendees from '../MeetingAttendees/MeetingAttendees';
import AgendaList from '../AgendaList/AgendaList';

// Styles
import './AgendaPanel.scss';

type Props = {
  meetingModeSession: Record<WorkspaceMeetingMode>;
  meetingItemOrderedKeys: Array<string>;
  handleNavigateToItem: Function;
};

const AgendaPanel = ({ meetingModeSession, meetingItemOrderedKeys, handleNavigateToItem }: Props) => {
  const baseClassName = 'AgendaPanel';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__header`}>
        <div className={`${baseClassName}__header__attendees`}>
          <MeetingAttendees meetingModeSession={meetingModeSession} />
        </div>
      </div>
      <div className={`${baseClassName}__agenda`}>
        <AgendaList
          meetingItemOrderedKeys={meetingItemOrderedKeys}
          meetingModeSession={meetingModeSession}
          handleNavigateToItem={handleNavigateToItem}
        />
      </div>
    </div>
  );
};

export default AgendaPanel;
